import React from 'react';
import MetricCard from './components/MetricCard/MetricCard';
import { METRICS_TITLES } from '../../../utils/constants/reports/violationReports.constants';
import { MetricsDashboardContainer } from './MetricsDashboard.styles';

const MetricsDashboard = ({ countViolationsByType, activeFilter = 'ALL', onFilterChange }) => {
  const handleOnchangeFilter = (type) => {
    onFilterChange(type);
  };

  return (
    <MetricsDashboardContainer>
      {METRICS_TITLES.map((metric) => (
        <MetricCard
          key={metric.id}
          metric={metric}
          handleOnchangeFilter={() => handleOnchangeFilter(metric.code)}
          violations={countViolationsByType[metric.code]}
          isActive={activeFilter === metric.type}
        />
      ))}
    </MetricsDashboardContainer>
  );
};

export default MetricsDashboard;
